import { CoreModel } from '../core/core.model';
export class JsonEditorRowButtonModel extends CoreModel {
/**
 * Button action name
 */
name: string;
/**
 * Icon name
 */
icon: string;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function JsonEditorRowButtonModel_tsickle_Closure_declarations() {
/**
 * Button action name
 * @type {?}
 */
JsonEditorRowButtonModel.prototype.name;
/**
 * Icon name
 * @type {?}
 */
JsonEditorRowButtonModel.prototype.icon;
}

